<template>
  <div class="bl-register-wrap">
    <div class="bl-bg-head"></div>
    <div class="bl-register-box">
      <div class="flex">
        <div class="theme-color pointer font-size-13" @click="goPrev" style="right: auto; left: 20px;">
          <span class="iconfont iconfanhui"></span>{{ $t('login2s.back') }}
        </div>
        <div class="theme-color pointer font-size-13 .m-r-4" @click="registrationBackHome">
          <span class="backHomeS">{{ $t('logins.backHome') }}</span>
        </div>
      </div>
      <v-register-step :stepType='registerId'></v-register-step>
      <div>
        <div class="v-register-comment">
          <div class="v-register-title v-register-flex">
            <div>
              {{ $t('resetPassword') }}
            </div>
          </div>
          <el-form action="" @keyup.enter.native="regLoginMess" label-position="top">
            <div class="v-pass-register-module p-b-24">
              <v-input type="password" :labelName="$t('password')" v-model="inputVal.password"></v-input>
              <v-input type="password" :labelName="$t('confirmPassword')" :placeholder="$t('newPasswordAgain')" v-model="inputVal.repassword"></v-input>
            </div>
            
            <el-button type="primary" :disabled="disabled" class="v-big-btn" @click="regLoginMess">{{ $t('Next') }}</el-button>
          </el-form>
          <div class="v-register-flex font-size-12 p-b-24 p-t-24">
            <div>
              <!-- <span>{{ $t('You sign up and agree') }}</span>
              <span class="theme-color pointer"><router-link to="/agreement" target="_blank"> {{ $t('Privacy agreement') }}</router-link></span> -->
            </div>
            <TouristChat />
          </div>
        </div>
      </div>
      <loginBottom></loginBottom>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { setPasswordByToken } from '@/api/index'
import { setToken, removeToken } from '@/utils/auth'
import vInput from '@/components/vInput'
import vRegisterStep from '@/components/login/register_step.vue'
import TouristChat from '@/components/chat/TouristChat'
import loginBottom from '@/components/login/loginBottom.vue'

export default {
  name: 'vRegister',
  components: {
    vInput,
    vRegisterStep,
    TouristChat,
    loginBottom
  },
  data() {
    return {
      registerId:3,
      // 类型(手机号|邮箱)
      type: 'email',
      // 显示(手机号|邮箱) 模块
      isPassLogin: true,
      // form 表单
      inputVal: {
        password: '',
        repassword: ''
      },
      disabled: false
    }
  },
  computed: {
    ...mapGetters(['language', 'subjectType', 'loginAccount'])
  },
  mounted() {
    window.PC.$RangersEventLoginAndRegister('Emailpasswordpage_view', {
        account: this.loginAccount
    })
    var lang;
    if(localStorage.getItem('language') == '' || localStorage.getItem('language') == null ||localStorage.getItem('language') == undefined ||localStorage.getItem('language') == 'undefined'){
      this.setLang(this.$route.query.languageType || 'en')
    }else {
      if(this.$route.query.languageType) {
        if(this.$route.query.languageType == 'cn') {
          lang = 'zh';
          if(localStorage.getItem('language') != lang) {
            this.setLang(lang)
          }
        } else if(this.$route.query.languageType == 'en'){
          lang = 'en';
          if(localStorage.getItem('language') != lang) {
            this.setLang(lang)
          }
        }
      }
    }
    if (!this.$route.query.token) {
      removeToken()
      this.$router.replace({ path: '/' })
    } else {
      setToken(this.$route.query.token)
    }

    this.$tracking('010301')
  },

  methods: {
    goPrev() {
      this.$router.replace({ path: '/register/email/1' })
    },
    setLang(language) {
      this.$i18n.locale = language
      this.$store.commit('SET_LANGUAGE', language)
      location.reload()
    },
    // 验证字段
    regLoginMess() {
      this.disabled = true
      let obj = this.inputVal
      let param = {}
      if (!obj.password) {
        this.$notify.error(this.$t('Please enter your password'))
        this.disabled = false
        return false
      } else if(obj.password !== obj.repassword) {
        this.$notify.error(this.$t('The two passwords you entered did not match'))
        this.disabled = false
        return false
      }
      window.PC.$RangersEventLoginAndRegister('Emailpasswordpage_continue_click', {
        account: this.loginAccount
      })
      param = JSON.parse(JSON.stringify(this.inputVal))
      param.password = this.$md5(param.password)
      delete param.repassword
      this.submit(param)
    },
    // 注册
    async submit(params) {
      await setPasswordByToken(params).then(async (res) => {
        if(res.data.code === 1000) {
          var data = res.data.data;
          await this.$store.commit('SET_LOGIN_ACCOUNT', data.currentLogonAccount)
          var obj = {};
          obj.email = data.currentLogonAccount
          if (!data.requiredSetPassword && data.requiredVisitorRegister) {
            // 完善个人信息
            await setToken(res.headers.authorization)
            await this.loginSuccess(params.subjectType, null, this.isPassLogin, obj)
          } else if (!data.requiredSetPassword && !data.requiredVisitorRegister) {
            // 去判断是否完成预登记 来进行操作
            await setToken(res.headers.authorization)
            await this.$store.dispatch('BaseInfo', data)
            await this.loginSuccess(params.subjectType)
          }
        } else {
          this.disabled = false
        }
      }).catch(()=>{
        this.disabled = false
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.v-register-comment{
  padding 70px 0;
}
</style>
